module.exports = __webpack_public_path__ + "static/11-456616dac3396ec4a900298aa1a21ed2.jpeg";